import charts from '../charts.js';
import printEmbed from './print-embed.js';
import moment from 'moment';
import Form from '../includes/form.js';
import SavedFilters from '../includes/filters.js';
import '../amcharts.js';

class ChartPage {
	numWeeks = 52;
	numHistoricalData;
	timePeriod = 'weeks';
	symbol;
	lastData;
	chartData;
	chart;
	section;
	toggles;
	firstZoom = false;
	isStandalonePage;
	hasRemainingData;
	data;

	constructor() {
		this.isStandalonePage = window.config.url.data[0] === 'chart';
	}

	async init({
		res,
		section,
		data,
		sectionName,
		embedSymbol = null,
		hasRemainingData = true,
		chartSettings,
		chartDefaults = null,
		timePeriod = 'weeks',
		sliderDefault = 52,
		callbacks = {},
		listeners = []
	}) {
		this.numHistoricalDataYears = res.numYears;
		this.numHistoricalData = res.numHistoricalData;
		this.symbol = res.symbol;
		this.lastData = res.lastData;
		this.firstData = res.chartData[0];
		this.chartData = res.chartData;
		this.section = section;
		this.callbacks = callbacks;
		this.hasRemainingData = hasRemainingData;
		this.data = data;

		if (!res.hasOwnProperty('chartData')) {
			return;
		}

		if (this.section.hasClass('stock-results-unavailable') || res.limitPopup) {
			return;
		}

		this.timePeriod = timePeriod;
		this.numWeeks = sliderDefault * (timePeriod === 'years' ? 52 : 1);

		if (!this.isStandalonePage) {
			this.form = Form.init(this.section);

			if (res.savedFilters) {
				await SavedFilters.init({
					section,
					form: this.form,
					title: res.filtersKey,
					savedSettings: res.savedSettings,
					lastSavedSettings: res.lastSavedSettings,
					skip: [ 'past_data_period', 'past_data_length_weeks', 'past_data_length_years' ],
					callback: () => {
						this.toggleTimePeriod(true);
						this.setNumWeeks(this.getCurrentWeeks(), true);

						if (this.chart) {
							this.drawChart();
						}
					},
				});
			} else {
				SavedFilters.initFiltersToggle();
			}
		}

		this.chart = chartSettings({
			id: 'chart-div-main',
			data: this.chartData,
			config: res,
			defaults: chartDefaults,
			dates: [ this.getStartDate(), this.getEndDate() ],
		});

		if (!this.isStandalonePage) {
			data.urlData[2] = this.symbol.toLowerCase();
			page._manageState(data, null, true);
		}

		if (this.form) {
			this.form.setCallback('past_data_period', 'set', () => this.toggleTimePeriod(false));
			this.form.setCallback('past_data_length_weeks', 'set', () => this.setNumWeeks(null));
			this.form.setCallback('past_data_length_years', 'set', () => this.setNumWeeks(null));
		}

		if (!this.isStandalonePage) {
			printEmbed(
				this.section,
				this.chart,
				{
					symbol: embedSymbol || this.symbol,
					type: sectionName,
					width: 720,
					height: 400,
				},
				this.callbacks.buildEmbed ?? null
			);
		}

		this.setNumWeeks(null, true);

		if (this.hasRemainingData === 'IMMEDIATE') {
			if (!this.isStandalonePage) {
				this.fetchRemainingData(this.data);
			}
		}
	}

	zoomChart() {
		const endDate = this.getEndDate();
		const startDate = this.getStartDate();

		this.chart.zoom(startDate, endDate);

		if (this.callbacks.setNumWeeks) {
			this.callbacks.setNumWeeks();
		}
	}

	getStartDate() {
		const date = moment(this.lastData.date).subtract(this.numWeeks * 7, 'day');
		const min = moment(this.firstData.date);

		return moment.max(date, min).toDate();
	}

	getEndDate() {
		if (this.callbacks.getEndDate) {
			return moment(this.callbacks.getEndDate()).add(1, 'day').toDate();
		}

		return moment(this.lastData.date).add(1, 'day').toDate();
	}

	getCurrentWeeks() {
		const weeks = this.form.get(`past_data_length_${this.timePeriod}`) * (this.timePeriod === 'weeks' ? 1 : 52);

		if (weeks > this.numHistoricalData) {
			return this.numHistoricalData;
		}

		return weeks;
	}

	setNumWeeks(value = null, noDraw = false) {
		if (value === null) {
			value = this.form ? this.getCurrentWeeks() : this.numWeeks;
		}

		this.numWeeks = value;

		if (this.form) {
			if (this.numWeeks > 52) {
				if (this.form.get('past_data_period') === 0) {
					this.form.set('past_data_period', true, true);
				}

				this.form.update('past_data_length_years', Math.floor(this.numWeeks / 52));
			}

			if (this.numWeeks < 52) {
				if (this.form.get('past_data_period') === 1) {
					this.form.set('past_data_period', false, true);
				}

				this.form.update('past_data_length_weeks', this.numWeeks);
			}

			if (this.numWeeks === 52) {
				if (this.timePeriod === 'years') {
					this.form.update('past_data_length_years', Math.floor(this.numWeeks / 52));
				} else {
					this.form.update('past_data_length_weeks', this.numWeeks);
				}
			}
		}

		if (!noDraw) {
			this.zoomChart();
		} else {
			if (this.callbacks.setNumWeeks) {
				this.callbacks.setNumWeeks();
			}
		}
	}

	drawChart() {
		if (this.callbacks.drawChart) {
			this.callbacks.drawChart();
		} else {

		}
	}
	refreshData() {
		this.chart.refreshData(this.chartData);
	}

	toggleTimePeriod(noDraw = false) {
		this.timePeriod = this.form.get('past_data_period') === 1 ? 'years' : 'weeks';

		$(`.data-length-slider.data-length-slider-${this.timePeriod}`).removeClass('hidden');
		$(`.data-length-slider:not(.data-length-slider-${this.timePeriod})`).addClass('hidden');

		this.setNumWeeks(this.getCurrentWeeks(), noDraw);

		if (this.timePeriod === 'years' && this.hasRemainingData === 'TOGGLE') {
			if (!this.isStandalonePage) {
				this.fetchRemainingData(this.data);
			}
		}
	}

	fetchRemainingData(data) {
		this.hasRemainingData = false;

		ajax('fetchRemainingData', data, res => {
			if (!this.chart?.root?.dom) {
				console.log('chart is gone');
				return;
			}

			if (res.symbol !== this.symbol) {
				return;
			}

			// console.log('updating with historical data');
			this.numHistoricalData = res.numHistoricalData;

			this.setData(res.chartData);

			if (this.callbacks.fetchRemianingData) {
				this.callbacks.fetchRemianingData();
			}

			// re-enable to ensure initial state is set properly after loading remaining data
			// ex. if saved state is 5 years, this needs to be refreshed since initial data won't be 5 years
			// this.setNumWeeks(this.getCurrentWeeks());
		});
	}

	getData() {
		return this.chartData;
	}

	setData(data) {
		this.chart.refreshData(data);
	}
}

export default ChartPage;
